import './polyfills';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { HashRouter } from 'react-router-dom';
import './assets/base.scss';
import configureStore from './config/configureStore';
import { Provider } from 'react-redux';
import Routes from './routes';
import history from './services/history';
import AppProvider from './Context';
import Loader from './Layout/AppLoader/index';

const store = configureStore();

function App() {
    return (
        <Provider store={store}>
            <AppProvider>
                <HashRouter history={history}>
                    <Loader />
                    <Routes />
                    <ToastContainer autoClose={3500} hideProgressBar />
                </HashRouter>
            </AppProvider>
        </Provider>
    );
}

export default App;
